import * as React from "react"
import * as member from "./members.module.css"
import PlaceholderImage from "../../images/Placeholder Image.jpg"

const MembersList = ({list}) => {
  return (
    <div className={`wrapped-content`}>
      <div className={member.wrapper}>
        {list && list.map(i => (
          <div className={member.card} key={i.name}>
            <div className={member.photo}>
              <img src={i.photo?.file?.url ? i.photo.file.url : PlaceholderImage} alt={i.name} />
            </div>
            <div className={member.info}>
              <h5 className={member.name}>{i.name}</h5>
              <p className={member.role}>{i.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MembersList
